module.exports = "/images/abstract2.jpg?76dee5f04ed330e1eedefaef61317dad";